import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import {
  receivingCategoryListByFilter,
  saveReceivingCatMutation,
} from '../../../shared/queries/ReceivingCategory';
import GraphQL from '../../../GraphQL';
import ReceivingCategoryForm from './Form';
import SmartCard from '../../../shared/components/SmartCard';

const ReceivingCatFormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({ id: 0 });
  const [formOn, setFormOn] = useState(false);

  function backClickHandler() {
    history.push('/minime/categoria-recebimento');
  }

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  function findById(id) {
    showLoading();
    const filter = {
      filterByStatus: false,
      updaterId: 0,
      active: true,
      id,
    };
    const query = receivingCategoryListByFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        if (res.receivingCategoryListByFilter) {
          setDto({
            ...res.receivingCategoryListByFilter[0],
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      })
      .finally(() => {
        hideLoading();
      });
  }

  const handleSubmit = (values) => {
    const mutation = saveReceivingCatMutation(values);
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  useEffect(() => setDto({ active: true, id: 0 }), []);

  return (
    <SmartCard title={t('panels.categoria-recebimento')}>
      {formOn ? (
        <ReceivingCategoryForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          dto={dto}
        />
      ) : null}
    </SmartCard>
  );
};

ReceivingCatFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ReceivingCatFormHandler)
);
